import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            showCaptcha: false,
            appIp: ''
        };
    },
    computed: {
        ...mapGetters({
            feCommon: 'getFeCommon'
        })
    },
    mounted() {
        this.appIp = this.feCommon.clientIP;
    },
    methods: {
        getVerify() {
            this.showCaptcha = true;
            this.$emit('init-captcha', this.showCaptcha);
        }
    }
};
